import { Navigate, Route, Routes, useOutletContext } from 'react-router';
import ProtectedRoute from '@/app/routing/ProtectedRoute';
import { UserRole } from '@/types';

type AppLayoutOutletContext = {
  isNewsletterAvailable: boolean;
};

import NewsletterAdminPage from '../pages/NewsletterAdminPage';
import NewsletterPublicPage from '../pages/NewsletterPublicPage';

const NewsletterRoutes = () => {
  const { isNewsletterAvailable } =
    useOutletContext<AppLayoutOutletContext>();

  if (!isNewsletterAvailable) {
    return <Navigate to="/applications" replace />;
  }

  return (
    <Routes>
      <Route path="" element={<NewsletterPublicPage />} />
      <Route
        path="admin"
        element={(
          <ProtectedRoute requiredRoles={[UserRole.RELEASE_NOTES_MANAGER]}>
            <NewsletterAdminPage />
          </ProtectedRoute>
        )}
      />
      <Route path="admin-local" element={<NewsletterAdminPage />} />
    </Routes>
  );
};

export default NewsletterRoutes;
